import styled from "styled-components";

const handleJustifyContent = (mode) => {
    switch (mode) {
        case "start":
            return "flex-start";

        case "end":
            return "flex-end";

        case "between":
            return "space-between";

        case "around":
            return "space-around";

        default:
            return mode || "normal";
    }
};

const handleAlignItems = (mode) => {
    switch (mode) {
        case "start":
            return "flex-start";

        case "end":
            return "flex-end";

        default:
            return mode || "normal";
    }
};

export const Flex = styled.div<{
    justify?: "start" | "end" | "between" | "around" | string;
    align?: "start" | "end" | string;
    equal?: boolean;
    direction?: "column" | "row" | "column-revers" | "row-reverse";
    gap?: number;
    adjustWidth?: boolean;
}>`
    display: flex;
    flex-direction: ${({ direction }) => direction || "row"};

    justify-content: ${(p) => handleJustifyContent(p.justify)};
    align-items: ${(p) => handleAlignItems(p.align)};
    margin: ${({ gap }) => -gap + "rem"};

    > * {
        flex: ${(p) => (p.equal ? "1 1 auto" : "0 1 auto")};
        width: ${(p) => (p.adjustWidth ? "100%" : "auto")};
        margin: ${({ gap }) => (gap ? gap + "rem" : "unset")};
    }
`;

export default Flex;
